import { render, staticRenderFns } from "./IconSelection.vue?vue&type=template&id=63317a16&"
import script from "./IconSelection.vue?vue&type=script&lang=js&"
export * from "./IconSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports